module.exports = __webpack_public_path__ + "static/drow_gunslinger-9c23d2ecb71796c5f308345a238e5ef5.png";